import { NEUTRAL_FONT_STACK, NEUTRAL_STYLESHEET_HEAD } from './palette'
import { focusOutlineRules, inputRules, primaryButtonRules } from './neutralFragments'

const neutralCardCss = ({ prefix, root = 'root', extra = '' }) => `
${NEUTRAL_STYLESHEET_HEAD}
.${prefix}-${root}, .${prefix}-${root} *, .${prefix}-${root} *::before, .${prefix}-${root} *::after { box-sizing: border-box; }
.${prefix}-${root} {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 32px 16px;
  background: var(--na-page-bg);
  color-scheme: var(--na-scheme);
  font-family: ${NEUTRAL_FONT_STACK};
  -webkit-font-smoothing: antialiased;
}
.na-portal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--na-brand-ink);
}
.${prefix}-card {
  width: 100%;
  max-width: 440px;
  padding: 44px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: var(--na-card);
  color: var(--na-ink);
  border: 1px solid var(--na-card-border);
  border-radius: 18px;
  box-shadow: var(--na-card-shadow);
}
.${prefix}-icon { flex: none; width: 48px; height: 48px; }
.${prefix}-icon-wrap { display: flex; justify-content: center; }
.${prefix}-card svg { color: var(--na-primary-soft); }
.${prefix}-card svg [stroke] { stroke: var(--na-primary-soft); }
.${prefix}-card svg text { fill: var(--na-primary-soft); }
.${prefix}-heading { margin: 0; font-size: 26px; font-weight: 600; letter-spacing: -0.01em; text-align: center; color: var(--na-ink); }
.${prefix}-subtitle { margin: 0; font-size: 16px; line-height: 1.55; text-align: center; color: var(--na-muted); }
.${prefix}-form { width: 100%; display: flex; flex-direction: column; gap: 14px; }
.${prefix}-field { width: 100%; display: flex; flex-direction: column; gap: 6px; }
.${prefix}-label { font-size: 14px; font-weight: 600; color: var(--na-ink); }
${inputRules(`.${prefix}-input`)}
.${prefix}-input--error { border-color: var(--na-error); }
${primaryButtonRules(`.${prefix}-btn`)}
.${prefix}-link, .${prefix}-link-btn {
  padding: 4px;
  background: none;
  border: none;
  color: var(--na-muted);
  font-family: inherit;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
}
.${prefix}-link:hover, .${prefix}-link-btn:hover { color: var(--na-link); text-decoration: underline; }
${focusOutlineRules(`.${prefix}-link`)}
${focusOutlineRules(`.${prefix}-link-btn`)}
.${prefix}-error { font-size: 13px; color: var(--na-error); }
@media (max-width: 480px) {
  .${prefix}-card { padding: 32px 22px; }
  .${prefix}-heading { font-size: 24px; }
}
${extra}
`

const NEUTRAL_CONFIRM_CODE_EXTRA = `
.cc-inputs { width: 100%; display: flex; gap: 8px; justify-content: center; }
.cc-digit {
  width: 48px;
  height: 54px;
  background: var(--na-input-bg);
  border: 1px solid var(--na-border);
  border-radius: 10px;
  color: var(--na-ink);
  font-family: inherit;
  font-size: 20px;
  text-align: center;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.cc-digit:focus { border-color: var(--na-focus-border); box-shadow: 0 0 0 3px var(--na-focus-ring); }
.cc-resend { font-size: 14px; color: var(--na-muted); }
.cc-resend-link {
  padding: 0;
  background: none;
  border: none;
  color: var(--na-link);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.cc-resend-link:hover { text-decoration: underline; }
${focusOutlineRules('.cc-resend-link')}
@media (max-width: 420px) {
  .cc-digit { width: 40px; height: 48px; font-size: 18px; }
}
`

export const NEUTRAL_FORGOT_CSS = neutralCardCss({ prefix: 'fp' })

export const NEUTRAL_CONFIRM_CODE_CSS = neutralCardCss({ prefix: 'cc', extra: NEUTRAL_CONFIRM_CODE_EXTRA })

export const NEUTRAL_RESET_CSS = neutralCardCss({ prefix: 'rp' })

export const NEUTRAL_CREATE_PASSWORD_CSS = neutralCardCss({ prefix: 'cp', root: 'page' })
